import { Box } from "@mui/material"
import React from "react"

type OverflowProps = {
	children?: React.ReactNode[] | React.ReactNode;
	height?: string | number;
	maxHeight?: string | number;
}

export function OverflowWrapper({ children = null, maxHeight = "460px", height = null }: OverflowProps): JSX.Element {
	return (
		<Box height={height} maxHeight={maxHeight} width='100%' overflow='scroll'>
			{children}
		</Box>
	)
}

export default OverflowWrapper
